// Kompas Dnia — date helpers.
// Local (not UTC) — a user must never lose a check-in because of timezones.

/**
 * Returns today's date as a YYYY-MM-DD string in the user's local timezone.
 */
export function todayLocalISO() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/**
 * Format a Date (or ISO date string) into a human-friendly, language-aware string.
 *   PL: "wtorek, 15 stycznia"
 *   EN: "Tuesday, January 15"
 */
export function formatDate(input, language = "pl") {
  const date = typeof input === "string" ? parseISODate(input) : input;
  const locale = language === "pl" ? "pl-PL" : "en-US";
  const options =
    language === "pl"
      ? { weekday: "long", day: "numeric", month: "long" }
      : { weekday: "long", month: "long", day: "numeric" };
  try {
    return new Intl.DateTimeFormat(locale, options).format(date);
  } catch {
    return typeof input === "string" ? input : date.toISOString().slice(0, 10);
  }
}

/**
 * Parse a YYYY-MM-DD string as a local-date Date (avoids UTC drift).
 */
export function parseISODate(iso) {
  if (typeof iso !== "string") return new Date();
  const [y, m, d] = iso.split("-").map(Number);
  if (!y || !m || !d) return new Date();
  return new Date(y, m - 1, d);
}
